import script from "./ValidazioneDocumenti.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidazioneDocumenti.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__